import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';


const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _emailTemplates = [];
let _templateStats = {};

const EmailTemplateStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _emailTemplates.filter(function(e) { return e !== undefined; });
    },
    getById: function(id) {
        return _emailTemplates.find(function(e){ return e !== undefined && e.id == id;} );
    },
    getByType: function(type) {
        return _emailTemplates.filter(function(e) { return e !== undefined && e.type == type; });
    },
    
    add: function(entity) {
        var templateId = _emailTemplates.findIndex(function(e) { return e !== undefined && e.id == entity.id;});
        if (0 <= templateId) {
            _emailTemplates[templateId] = entity;
        } else {
            _emailTemplates.push(entity);
        }
    },
    delete: function(data) {
        var templateId = _emailTemplates.findIndex(function(e) { return e !== undefined && e.id == data.id;});
        if (0 <= templateId) {
            if (!!data.deleted) {
                delete _emailTemplates[templateId];
            } // else restore?
        }
    },
    getStats: function() {
        return _templateStats;
    },

});

EmailTemplateStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.EMAIL_TEMPLATE_LIST:
            action.data.forEach(EmailTemplateStore.add);
            EmailTemplateStore.emitChange();
            break;

        case ActionTypes.EMAIL_TEMPLATE_LIST_ERROR:
            EmailTemplateStore.emitChange();
            break;

        case ActionTypes.EMAIL_TEMPLATE_INFO:
        case ActionTypes.EMAIL_TEMPLATE_UPDATE:
            EmailTemplateStore.add(action.data);
            EmailTemplateStore.emitChange();
            break;

        case ActionTypes.EMAIL_TEMPLATE_INFO_ERROR:
            EmailTemplateStore.emitChange();
            break;

        case ActionTypes.EMAIL_TEMPLATE_SAVE:
            EmailTemplateStore.add(action.data);
            EmailTemplateStore.emitChange();
            break;


        case ActionTypes.EMAIL_TEMPLATE_DELETE:
            EmailTemplateStore.delete(action.data);
            EmailTemplateStore.emitChange();
            break;

        case ActionTypes.EMAIL_TEMPLATE_STATS:
            _templateStats = action.data;
            EmailTemplateStore.emitChange();
            break;

        default:
            break;

    }

});

export default EmailTemplateStore;
